import * as types from './types'
export default {
  [types.CANCEL_NEWSCANTOOL](state) {
    state.scantools = state.scantools.filter((item) => item.id !== 0)
  },
  [types.ADD_SCANTOOL](state, scantool) {
    var cnt = 0
    for (const item of state.scantools) {
      if (item.id === 0) {
        cnt++
      }
    }
    if (cnt === 0) {
      state.scantools.unshift(scantool)
    }
  },
  [types.SET_SCANTOOLS](state, data) {
    state.scantools = []
    if (
      data !== undefined &&
      data !== null
    ) {
      for (const item of data) {
        state.scantools.push({
          id: item.id,
          name: item.name,
          makeId: item.makeId,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          appId: item.appId,
          isInactive: item.isInactive,
          isChanged: false
        })
      }
    }
  },
  [types.SET_SCANTOOL](state, data) {
    if (state.scantools !== null && data !== null) {
      for (const item of state.scantools) {
        if (item.id === data.id) {
          item[data.name] = data.value
          if (item.name === 'id') {
            item.isChanged = false
          } else {
            item.isChanged = true
          }
          break
        }
      }
    }
  },
  [types.CANCEL_NEWREPORTTEMPLATE](state) {
    state.reportTemplates = state.reportTemplates.filter((item) => item.id !== 0)
  },
  [types.ADD_REPORT_TEMPLATE](state, template) {
    var cnt = 0
    for (const item of state.reportTemplates) {
      if (item.id === 0) {
        cnt++
      }
    }
    if (cnt === 0) {
      state.reportTemplates.unshift(template)
    }
  },
  [types.SET_REPORT_TEMPLATES](state, data) {
    state.reportTemplates = []
    if (
      data !== undefined &&
      data !== null
    ) {
      for (const item of data) {
        state.reportTemplates.push({
          id: item.id,
          area: item.area,
          productId: item.productId,
          order: item.order,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          template: item.template,
          appId: item.appId,
          isInactive: item.isInactive,
          isAdd: item.isAdd,
          isChanged: false
        })
      }
    }
  },
  [types.SET_REPORT_TEMPLATE](state, data) {
    if (state.reportTemplates !== null && data !== null) {
      for (const item of state.reportTemplates) {
        if (item.id === data.id) {
          item[data.name] = data.value
          if (item.name === 'id') {
            item.isChanged = false
          } else {
            item.isChanged = true
          }
          break
        }
      }
    }
  },
  [types.SAVE_TECH_INFO](state, tech) {
    localStorage.setItem('techInfo', JSON.stringify(tech))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report/mutations.js